import { SET_URL_PARAMS } from './index'

export const setInstallationParams = (payload) => ({
  type: SET_URL_PARAMS,
  payload,
})

export default setInstallationParams
